module.exports = __webpack_public_path__ + "img/2024-09-19d_2.e71ea199.jpg";